import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getAdvanced } from '../../utils';
export default (function (node) {
  return _objectSpread({
    isSameWidth: node.getAttribute('data-same-width') === 'true'
  }, getAdvanced(node));
});